import React, { useContext, useState, useEffect, useMemo, useCallback } from "react";

import { helpers } from "@acadia-ui/theme";

import DataStore from "../../../Flux/Stores/PackagesDataStore";
import { fetchPackages } from "../../../Flux/Actions/PackagesActions";
import LegacyPackageView from "../features/LegacyViews/LegacyPackageView";
import PlacementDataStore from "../../../Flux/Stores/PlacementDataStore";

const classNameComponent = `gos-workbook__auditlevel-package`;
const classNamePrefix = `${classNameComponent}__`;

export default function usePackage({
	// this comment exists to prevent eslint from making this unreadable.
	auditLevel,
	parentCampaignUniqueID,
	metaData,
	auditLevels,
	navigateToPlacements,
	fetchMetaData,
	placementAPI,
	JIRAStatus,
	setSelectedPackage
}) {
	const [data, setData] = useState();
	const [config, setConfig] = useState();

	useEffect(() => {
		setData(null);
		setConfig(null);
	}, [parentCampaignUniqueID]);

	const refresh = useCallback(async (parentCampaignUniqueID, auditLevel) => {
		if (parentCampaignUniqueID && auditLevel) {
			try {
				await fetchPackages(
					{
						platform: { value: auditLevel.PlatformID },
						auditlevel: { value: auditLevel.AuditLevelID }
					},
					parentCampaignUniqueID
				);
				setData(DataStore.getData());
				setConfig(DataStore.getConfig());
			} catch (e) {
				setData(null);
				setConfig(null);
			}
		}
	}, []);

	useEffect(() => {
		const updateConfig = () => {
			setConfig(PlacementDataStore.getConfig());

			setTimeout(() => {
				if (DataStore.getNavigate()) {
					navigateToPlacements?.();
				}
			}, 10);
		};
		PlacementDataStore.on("placement_config_loaded", updateConfig);
		return () => PlacementDataStore.removeListener("placement_config_loaded", updateConfig);
	}, []);

	helpers.useAsyncEffect(() => {
		if (parentCampaignUniqueID && auditLevel && metaData.CampaignUniqueIDCode == parentCampaignUniqueID && auditLevel.PlatformID == metaData.PlatformID) {
			refresh(parentCampaignUniqueID, auditLevel);
		}
	}, [parentCampaignUniqueID, auditLevel]);

	const Component = useCallback(
		({ refreshMap }) => {
			if (data && config && metaData && fetchMetaData && refreshMap) {
				return (
					<div className={`gos-workbook__auditlevel ${classNameComponent}`}>
						<LegacyPackageView
							campaignMetaData={metaData}
							placementAPI={placementAPI}
							JIRAStatus={JIRAStatus}
							auditLevelData={auditLevels}
							navigateToPlacements={navigateToPlacements}
							getCount={() => {}}
							getPlacementCount={() => {}}
							updateCounts={async () => {
								// ["Package", "Placement"].forEach((name) => refreshMap?.[name]?.());
								await refreshMap?.Placement?.();
								await refreshMap?.Package?.();
							}}
							updateMetaData={fetchMetaData}
							tabNames={auditLevels?.map(({ AuditLevelName }) => AuditLevelName) || []}
							setSelectedPackage={setSelectedPackage}
						/>
					</div>
				);
			}
			return <></>;
		},
		[data, config, metaData, fetchMetaData, setSelectedPackage]
	);

	return useMemo(
		() => ({
			Component,
			data,
			refresh
		}),
		[Component, data, refresh]
	);
}
